/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetTerms200Response } from '../models';
/**
 * TermsApi - axios parameter creator
 * @export
 */
export const TermsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 결제 서비스 이용약관을 조회합니다.  **지원하는 약관 타입:** - electronicFinancialTransactions: 전자금융거래 약관 - collectPersonalInfo: 개인정보 수집·이용 약관 - sharingPersonalInformation: 개인정보 제3자 제공 약관 - telecommunicationCharging: 통신과금 서비스 약관  **사용 예시:** - 전체 약관 조회: `GET /api/v1/terms` - 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions` 
         * @summary 약관 조회
         * @param {GetTermsTermsTypeEnum} [termsType] 조회할 약관 타입 (생략 시 전체 약관 조회)
         * @param {GetTermsLanguageEnum} [language] 언어 코드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerms: async (termsType?: GetTermsTermsTypeEnum, language?: GetTermsLanguageEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termsType !== undefined) {
                localVarQueryParameter['termsType'] = termsType;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermsApi - functional programming interface
 * @export
 */
export const TermsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermsApiAxiosParamCreator(configuration)
    return {
        /**
         * 결제 서비스 이용약관을 조회합니다.  **지원하는 약관 타입:** - electronicFinancialTransactions: 전자금융거래 약관 - collectPersonalInfo: 개인정보 수집·이용 약관 - sharingPersonalInformation: 개인정보 제3자 제공 약관 - telecommunicationCharging: 통신과금 서비스 약관  **사용 예시:** - 전체 약관 조회: `GET /api/v1/terms` - 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions` 
         * @summary 약관 조회
         * @param {GetTermsTermsTypeEnum} [termsType] 조회할 약관 타입 (생략 시 전체 약관 조회)
         * @param {GetTermsLanguageEnum} [language] 언어 코드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerms(termsType?: GetTermsTermsTypeEnum, language?: GetTermsLanguageEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTerms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerms(termsType, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TermsApi.getTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TermsApi - factory interface
 * @export
 */
export const TermsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermsApiFp(configuration)
    return {
        /**
         * 결제 서비스 이용약관을 조회합니다.  **지원하는 약관 타입:** - electronicFinancialTransactions: 전자금융거래 약관 - collectPersonalInfo: 개인정보 수집·이용 약관 - sharingPersonalInformation: 개인정보 제3자 제공 약관 - telecommunicationCharging: 통신과금 서비스 약관  **사용 예시:** - 전체 약관 조회: `GET /api/v1/terms` - 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions` 
         * @summary 약관 조회
         * @param {TermsApiGetTermsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerms(requestParameters: TermsApiGetTermsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetTerms200Response> {
            return localVarFp.getTerms(requestParameters.termsType, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermsApi - interface
 * @export
 * @interface TermsApi
 */
export interface TermsApiInterface {
    /**
     * 결제 서비스 이용약관을 조회합니다.  **지원하는 약관 타입:** - electronicFinancialTransactions: 전자금융거래 약관 - collectPersonalInfo: 개인정보 수집·이용 약관 - sharingPersonalInformation: 개인정보 제3자 제공 약관 - telecommunicationCharging: 통신과금 서비스 약관  **사용 예시:** - 전체 약관 조회: `GET /api/v1/terms` - 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions` 
     * @summary 약관 조회
     * @param {TermsApiGetTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsApiInterface
     */
    getTerms(requestParameters?: TermsApiGetTermsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTerms200Response>;

}

/**
 * Request parameters for getTerms operation in TermsApi.
 * @export
 * @interface TermsApiGetTermsRequest
 */
export interface TermsApiGetTermsRequest {
    /**
     * 조회할 약관 타입 (생략 시 전체 약관 조회)
     * @type {'electronicFinancialTransactions' | 'collectPersonalInfo' | 'sharingPersonalInformation' | 'telecommunicationCharging'}
     * @memberof TermsApiGetTerms
     */
    readonly termsType?: GetTermsTermsTypeEnum

    /**
     * 언어 코드
     * @type {'ko' | 'en'}
     * @memberof TermsApiGetTerms
     */
    readonly language?: GetTermsLanguageEnum
}

/**
 * TermsApi - object-oriented interface
 * @export
 * @class TermsApi
 * @extends {BaseAPI}
 */
export class TermsApi extends BaseAPI implements TermsApiInterface {
    /**
     * 결제 서비스 이용약관을 조회합니다.  **지원하는 약관 타입:** - electronicFinancialTransactions: 전자금융거래 약관 - collectPersonalInfo: 개인정보 수집·이용 약관 - sharingPersonalInformation: 개인정보 제3자 제공 약관 - telecommunicationCharging: 통신과금 서비스 약관  **사용 예시:** - 전체 약관 조회: `GET /api/v1/terms` - 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions` 
     * @summary 약관 조회
     * @param {TermsApiGetTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsApi
     */
    public getTerms(requestParameters: TermsApiGetTermsRequest = {}, options?: RawAxiosRequestConfig) {
        return TermsApiFp(this.configuration).getTerms(requestParameters.termsType, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetTermsTermsTypeEnum = {
    ElectronicFinancialTransactions: 'electronicFinancialTransactions',
    CollectPersonalInfo: 'collectPersonalInfo',
    SharingPersonalInformation: 'sharingPersonalInformation',
    TelecommunicationCharging: 'telecommunicationCharging'
} as const;
export type GetTermsTermsTypeEnum = typeof GetTermsTermsTypeEnum[keyof typeof GetTermsTermsTypeEnum];
/**
 * @export
 */
export const GetTermsLanguageEnum = {
    Ko: 'ko',
    En: 'en'
} as const;
export type GetTermsLanguageEnum = typeof GetTermsLanguageEnum[keyof typeof GetTermsLanguageEnum];
